module.exports = __webpack_public_path__ + "img/thumb-jobbatical.f5bf1ed4.png";